import React from "react";
import {
  Dialog,
  styled,
  LinearProgress,
  linearProgressClasses,
} from "@mui/material";
import { useScale } from "common/utils";
import Constants, { BASE_WIDTH, BASE_HEIGHT } from "common/constant";
import { TitleSvg } from "features/home/assets";

const LoadingImage = React.memo(() => {
  const { scale } = useScale();
  return (
    <img
      alt="ローディング画像"
      src={`${Constants.assetHost}/assets/images/loading.gif`}
      style={{
        width: BASE_WIDTH,
        height: BASE_HEIGHT,
        transform: `translateZ(0) scale(${scale})`,
      }}
    />
  );
});

const BorderLinearProgress = styled(LinearProgress)(() => ({
  height: "100%",
  borderRadius: 8,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "#F0DCCC",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 8,
    transition: "none",
    backgroundColor: "#DCA082",
  },
}));

export const AssetLoading = ({
  open,
  progress,
}: {
  open: boolean;
  progress: number;
}) => {
  const TITLE_WIDTH = 828;
  const TITLE_HEIGHT = 182;
  const { height, scale } = useScale();

  return (
    <Dialog
      fullScreen
      maxWidth={false}
      open={open}
      sx={{ zIndex: 9999 }}
      PaperProps={{ style: { backgroundColor: "transparent" } }}
    >
      <div className="flex-col-el absolute top-0 left-0">
        {/* preload material symbols fonts */}
        <span className="material-symbols-outlined text-transparent">
          close
        </span>
      </div>

      <div className="h-full flex-row-center bg-[#f8f1e8]">
        <div
          className="flex-col-el self-center absolute z-50"
          style={{
            top: 16 * scale,
            width: TITLE_WIDTH * scale,
            height: TITLE_HEIGHT * scale,
          }}
        >
          <div
            className="flex-col-view origin-top-left"
            style={{
              width: TITLE_WIDTH,
              height: TITLE_HEIGHT,
              transform: `scale(${scale})`,
            }}
          >
            <TitleSvg />
          </div>
        </div>

        <LoadingImage />
        <div
          className="!absolute flex-col-center origin-top"
          style={{
            top: 673 * (height / BASE_HEIGHT),
            transform: `scale(${scale})`,
          }}
        >
          <div className="w-[360px] h-[16px]">
            <BorderLinearProgress variant="determinate" value={progress} />
            <p className="text !text-[36px] text-[#ffa03b] tracking-[.2em]">
              {progress > 99 ? 99 : progress}%
            </p>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
